import { render } from "./SetResponsiblePerson.vue?vue&type=template&id=7feffaf9"
import script from "./SetResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./SetResponsiblePerson.vue?vue&type=script&lang=js"

import "./SetResponsiblePerson.vue?vue&type=style&index=0&id=7feffaf9&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__